import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Tooltip,
} from '@mui/material';
import { useStore } from '../store/useStore';

const BookingHistory = () => {
  const { bookings, cancelBooking } = useStore();
  // const { bookings, cancelBooking }: any = useState({});

  const canCancelBooking = (status: string) => {
    return status === 'pending';
  };
  // console.log(bookings)
  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Booking History
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Booking ID</TableCell>
              <TableCell>Check-in</TableCell>
              <TableCell>Check-out</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Total Amount</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookings.map((booking: any) => (
              <TableRow key={booking?.id}>
                <TableCell>{booking?.id}</TableCell>
                <TableCell>
                  {booking?.checkIn?.toDateString && booking?.checkIn?.toDateString()}
                </TableCell>
                <TableCell>
                  {booking?.checkOut?.toDateString && booking?.checkOut?.toDateString()}
                </TableCell>
                <TableCell>{booking?.status}</TableCell>
                <TableCell>₹{booking?.totalAmount}</TableCell>
                <TableCell>
                  {canCancelBooking(booking?.status) ? (
                    <Button
                      size="small"
                      color="error"
                      onClick={() => cancelBooking(booking?.id)}
                    >
                      Cancel
                    </Button>
                  ) : (
                    <Tooltip title="Booking cannot be cancelled after being confirmed or rejected">
                      <span>
                        <Button
                          size="small"
                          color="error"
                          disabled
                        >
                          Cancel
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default BookingHistory;
